<!-- Full-cover overlay showing a centered loading spinner with optional message. -->

<script lang="ts" setup>
import { classProp } from '@nzyme/vue-utils/classProp.js';

import Loader from './Loader.vue';

const props = defineProps({
  class: classProp,
});
</script>

<template>
  <div :class="[css.loader, props.class]">
    <Loader :class="css.icon" />
    <slot />
  </div>
</template>

<style lang="scss" module="css">
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  z-index: 1;
}

.icon {
  width: 30px;
  height: 30px;
  color: $color-blue-600;
}
</style>
